import { Typography } from "antd";
import Segment, { SegmentContainer } from "components/atoms/Segment";
import PageLayout from "components/molecules/PageLayout";
import DataSetAskAIContent from "components/organisms/DataSetAskAIContent";
import DataSetAssistantContent from "components/organisms/DataSetAssistantContent";
import DataSets from "containers/DataSets";
import UserBusinessAreaSchemaWrapper from "containers/UserBusinessAreaSchemaWrapper";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { clearAiHighlightedDataObjects } from "store/dataObjects/actions";

function usePreviousAction(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const DataSetPage = (props) => {
    const { tenant, businessarea, schema, dataSetAction, dataSetId } = useParams();
    const prevDataSetAction = usePreviousAction(dataSetAction);
    const dispatch = useDispatch();

    const showAssistant = dataSetAction === "view" || dataSetAction === "edit";

    return (
        <PageLayout
            key={`${businessarea}_${schema}_datasets_page`}
            border={false}
            mainContent={({ setBreadcrumbNavigationItems }) => {
                return (
                    <SegmentContainer>
                        <Segment shadow>
                            <UserBusinessAreaSchemaWrapper key={`${businessarea}_${schema}_wrapper`} tenant={tenant} businessArea={businessarea.toLowerCase()} schema={schema}>
                                {(childProps) => (
                                    <DataSets
                                        key={`${businessarea}_${schema}_${dataSetAction || "default"}_datasets`}
                                        setBreadcrumbNavigationItems={setBreadcrumbNavigationItems}
                                        tenant={tenant}
                                        businessArea={businessarea.toLowerCase()}
                                        schema={schema}
                                        action={dataSetAction}
                                        prevAction={prevDataSetAction}
                                        dataSetId={dataSetId}
                                        displaySize="full"
                                        {...childProps}
                                    ></DataSets>
                                )}
                            </UserBusinessAreaSchemaWrapper>
                        </Segment>
                    </SegmentContainer>
                );
            }}
            helpContent={<Typography>We're working on this documentation.</Typography>}
            askAIContent={showAssistant && dataSetId ? <DataSetAskAIContent dataSetId={dataSetId} /> : undefined}
            askAITitle="Dataset AI Summary"
            assistantContent={showAssistant ? <DataSetAssistantContent action={dataSetAction} /> : undefined}
            assistantTitle="Data Set Assistant"
            assistantOnClose={() => dispatch(clearAiHighlightedDataObjects())}
        ></PageLayout>
    );
};

export default DataSetPage;
